<div class="reflection-mood">
  <span class="reflection-mood-title" [attr.aria-description]="'reflections_mood_title' | localize" tabindex="0">{{ "reflections_mood_title" | localize }}?</span>
  <div class="reflection-mood-selector sp-mt-12" [class.read-only]="!isEditModeEnabled">
    <button
      class="reflection-mood-selector-button"
      *ngFor="let mood of reflectionMoodTypes"
      [attr.aria-label]="buildAriaLabelByMood(mood) + (reflectionMood === mood ? ', selected' : '')"
      [attr.data-test-id]="'check-in-mood-' + mood + '-btn'"
      (click)="updateMood(mood)"
      ui-button>
      <i
        [uiType]="mood"
        [class]="'reflection-mood-selector-icon ' + mood"
        [ngClass]="{ selected: reflectionMood === mood, 'not-selected': reflectionMood !== mood && !isEditModeEnabled, 'check-ins-ux-improvements': isCheckInsUxImprovementsEnabled }"
        ui-icon></i>
    </button>
  </div>
</div>
